export const DEFAULT_HIDE_ON_LOADING = false;